import { createNode, DateLikeUnion } from '@glueapp/graph-types';
import { Temporal } from '@js-temporal/polyfill';
import { objectToTemporal } from '../../utils/temporal';

export const GetDateInfo = createNode({
    id: 'Get Date Info',
    name: 'Get Date Info',
    description: 'Extracts detailed date properties from a Date, DateTime, or ZonedDateTime',
    aiDescription:
        'Takes a date-like value on the "Value" port and outputs its components on "Year", "Month", "Day", "Day of Week", "Day of Year", "Week of Year", "Days in Month", and "In Leap Year" ports.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        Value: { kind: 'generic', identifier: 'T', extends: DateLikeUnion },
    },
    outPorts: {
        Year: { kind: 'number' },
        Month: { kind: 'number' },
        Day: { kind: 'number' },
        'Day of Week': { kind: 'number' },
        'Day of Year': { kind: 'number' },
        'Week of Year': { kind: 'number' },
        'Days in Month': { kind: 'number' },
        'In Leap Year': { kind: 'boolean' },
    },
    execute: function (input) {
        const temporal = objectToTemporal(input.inPorts.Value);

        let dateLike: Temporal.PlainDate;
        if (temporal instanceof Temporal.ZonedDateTime) {
            dateLike = temporal.toPlainDate();
        } else if (temporal instanceof Temporal.PlainDateTime) {
            dateLike = temporal.toPlainDate();
        } else {
            dateLike = temporal as Temporal.PlainDate;
        }

        return {
            output: {
                Year: dateLike.year,
                Month: dateLike.month,
                Day: dateLike.day,
                'Day of Week': dateLike.dayOfWeek,
                'Day of Year': dateLike.dayOfYear,
                'Week of Year': dateLike.weekOfYear ?? 0,
                'Days in Month': dateLike.daysInMonth,
                'In Leap Year': dateLike.inLeapYear,
            },
        };
    },
});
